import { getUploadSignatureFileSizeString } from "src/utils/getUploadSizeString";

export const DROP_BOX_DESCRIPTION = `Maximum file size is ${getUploadSignatureFileSizeString()}. Required file format is PNG and image must be transparent`;
